module.exports = require('../full');